import { render, staticRenderFns } from "./USC_AT15_AT07_R1.vue?vue&type=template&id=70938e8a"
import script from "./USC_AT15_AT07_R1.vue?vue&type=script&lang=js"
export * from "./USC_AT15_AT07_R1.vue?vue&type=script&lang=js"
import style0 from "./USC_AT15_AT07_R1.vue?vue&type=style&index=0&id=70938e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports